<template>
  <div class="container" v-bind:class="cssStepValue">
    <div class="rcv__footer-row">
      <!-- Start button (initial state) -->
      <div class="rcv__footer-right" v-if="parseInt(instruction) === 0">
        <a href="javascript:void(0)" class="rcv__btn rcv__btn__secondary" role="button" aria-label="Start click"
        @click="onStartClick($event)">
          <span>{{ start }}</span>
        </a>
      </div>
      <!-- Back button to start page -->
      <div class="rcv__footer-left" v-if="parseInt(instruction) == 1">
        <a href="#" class="rcv__btn rcv__btn__primary" role="button" aria-label="Go back to the start page"
          @click="backToStartPage($event)">
          <span><i>&lt;</i> Back </span>
        </a>
      </div>

      <!-- Back button -->
      <div class="rcv__footer-left" v-if="parseInt(instruction) > 1 && parseInt(instruction) <= 6">
        <a href="#" class="rcv__btn rcv__btn__primary" role="button" aria-label="Go back to the previous page"
          @click="onprevious($event)">
          <span><i>&lt;</i> Back</span>
        </a>
      </div>

      <!-- Round 1 button -->
      <div class="rcv__footer-right" v-if="parseInt(instruction) === 1">
        <a href="javascript:void(0)" class="rcv__btn rcv__btn__secondary" role="button" aria-label="Start"
          @click="onnext($event)">
          <span>{{ nextRoundText }}</span>
        </a>
      </div>

      <!-- Exit button -->
      <div class="rcv__footer-right" v-if="parseInt(instruction) === 6">
        <a href="javascript:void(0)" class="rcv__btn rcv__btn__secondary" alt="exit ballot" role="button" width="120px"
          @click="onExitClick($event)">
          <span>{{ nextRoundText }}</span>
        </a>
      </div>

      <!-- Next button for rounds 2-5 -->
      <div class="rcv__footer-right" v-if="parseInt(instruction) > 1 && parseInt(instruction) < 6">
        <a href="javascript:void(0)" class="rcv__btn rcv__btn__secondary" role="button" aria-label="next round"
          @click="onnext($event)">
          <span>{{ nextRoundText }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterComponent",

  props: {
    instruction: {
      required: true
    },
    disable: Boolean,
    showBackButton: Boolean,
    start: String,
    currentState: String,
    exitButtonLink: {
      type: String,
      required: false,
      default: '#'
    },
    buttonLabels: {
      required: true
    }
  },

  computed: {
    cssStepValue() {
      let cssStepValue = "";
      const instructionValue = parseInt(this.instruction);

      if (instructionValue === 1) {
        cssStepValue = "stepOne";
      } else if (instructionValue === 6) {
        cssStepValue = "stepSix";
      }
      return cssStepValue;
    },

    // Dynamically fetch the button label for the current instruction
    nextRoundText() {
      const instructionValue = parseInt(this.instruction);

      // Ensure buttonLabels exists and has the correct index
      if (this.buttonLabels && this.buttonLabels[instructionValue - 1]) {
        return this.buttonLabels[instructionValue - 1];
      }

      // Fallback label if no match is found
      return "Next";
    }
  },

  methods: {
    onStartClick(event) {
     // this.$emit('start-clicked');
      this.preventScrollAndEmit('start-clicked', event);
     // this.focusBarChart();
    },
    onprevious(event) {
     // this.$emit("onprevious");
     // this.focusBarChart();
      this.preventScrollAndEmit('onprevious', event);
    },
    onnext(event) {
      if (window.innerWidth < 768 && parseInt(this.instruction) === 5) {
        this.preventScrollAndEmit('onnext', event);
        // Add a small delay to ensure the DOM has updated
        setTimeout(() => {
          this.$nextTick(() => {
            const instructionsElement = document.querySelector('.instructions');
            const headingElement = document.querySelector('.rcv__header');
            
            if (instructionsElement && headingElement) {
              // Get the element positions
              const instructionsRect = instructionsElement.getBoundingClientRect();
              const windowHeight = window.innerHeight;
              
              // Check if instructions are visible in viewport (scrolled down)
              if (instructionsRect.top <= windowHeight && instructionsRect.bottom >= 0) {
                headingElement.scrollIntoView({ behavior: 'smooth' });
              }
            }
          });
        }, 100);
      } else {
        this.preventScrollAndEmit('onnext', event);
      }
    },
    onreset(event) {
      // this.$emit("onreset");
      // this.focusBarChart();
      this.preventScrollAndEmit('onreset', event);
    },
    backToStartPage(event) {
      // this.$emit("backToStartPageClicked");
      // this.focusBarChart();
       this.preventScrollAndEmit('backToStartPageClicked', event);

    },
    onExitClick(event) {
      // Check if exitButtonLink exists and redirect to it
      // if (this.exitButtonLink && this.exitButtonLink.trim() !== '') {
      //   window.location.href = this.exitButtonLink;
      // } 
      // this.focusBarChart();
      event.preventDefault();
      if (this.exitButtonLink && this.exitButtonLink.trim() !== '') {
        window.location.href = this.exitButtonLink;
      }
    },
  preventScrollAndEmit(eventName, event) {
    // Prevent default behavior
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Store current scroll position
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    
    // Temporarily prevent scrolling
    document.body.style.overflow = 'hidden';
    
    // Emit the event
    this.$emit(eventName);
    
    // Reset scroll position and re-enable scrolling after a short delay
    this.$nextTick(() => {
      requestAnimationFrame(() => {
        window.scrollTo(0, currentScroll);
        // Re-enable scrolling after ensuring scroll position is maintained
        setTimeout(() => {
          document.body.style.overflow = '';
        }, 100);
      });
    });
  },

  preventScroll(e) {
    // Only prevent scroll if it's a button interaction
    if (e.target.closest('.rcv__btn')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
    
  },
  mounted() {
    // We don't need the touchmove handler anymore since we're only preventing scroll on button clicks
  },
  beforeDestroy() {
    // No need to remove handlers
  },

};
</script>



// WEBPACK FOOTER //
// src/components/PracticeRcvv2/FooterButtonComponent.vue